import TruckingReactAPI from '../../lib/TruckingReactAPI';
import { handleError, error, receive, request } from '../../lib/Utils';

export const USERS = {
  REQUEST: "USERS_REQUEST",
  SUCCESS: "USERS_SUCCESS",
  FAILURE: "USERS_FAILURE",
  RESET: "USERS_RESET"
};

export const SIGNUP = {
  REQUEST: "SIGNUP_REQUEST",
  SUCCESS: "SIGNUP_SUCCESS",
  FAILURE: "SIGNUP_FAILURE",
  RESET: "SIGNUP_RESET"
};

export const DELETE_USERS = {
  REQUEST: "DELETE_USERS_REQUEST",
  SUCCESS: "DELETE_USERS_SUCCESS",
  FAILURE: "DELETE_USERS_FAILURE",
  RESET: "DELETE_USERS_RESET"
};


let api = new TruckingReactAPI({ domain: '/api' });

export function getUsers(callback = () => false) {
  return (dispatch) => {
    dispatch(request(USERS));
    return api
      .getUsers()
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(USERS, json));
            });
        } else {
          handleError(dispatch, payload, USERS);
        }
      })
      .catch(function (err) {
        dispatch(error(USERS, { message: err.message }));
      });
  };
}

export function signup(user, callback = () => false) {
  return (dispatch) => {
    let parameters = {
      user: user
    };
    dispatch(request(SIGNUP));
    return api
      .signup(parameters)
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(SIGNUP, json));
              if (callback) {
                callback(null, json);
              }
            });
        } else {
          handleError(dispatch, payload, SIGNUP, callback);
        }
      })
      .catch(function (err) {
        dispatch(error(SIGNUP, { message: err.message }));
        if (callback) {
          callback(err);
        }
      });
  };
}

export function deleteUsers(ids, callback = () => false) {
  return (dispatch) => {
    dispatch(request(DELETE_USERS));
    return api
      .deleteUsers({
        userIds: ids
      })
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(DELETE_USERS, json));
              callback(null, json);
            });
        } else {
          handleError(dispatch, payload, DELETE_USERS, callback);          
        }
      })
      .catch(err =>{
        dispatch(error(DELETE_USERS, { message: err.message }));
        callback(err);
      });
  };

}


// WEBPACK FOOTER //
// ./src/containers/Users/UsersActions.js